/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-summary-label': 'Resumir',
  'copy-content-link-label': 'Copiar link',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Comece a digitar para pesquisar uma categoria',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Todos',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrar pesquisa por produto',
  'dynamic-cards-search-page.app-filter-sidebar.group-appify': 'Filtre a pesquisa por aplicativo',
  'dynamic-cards-search-page.atlas.for': 'para',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Calendário',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Participar da reunião',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Link da reunião',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Participar da reunião',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Eventos anteriores',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Evento recorrente',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Recorrente',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Próximos eventos',
  'dynamic-cards-search-page.compass.owner-name': 'Pertence a {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Nível {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Buscar conteúdo',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Selecionado',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Sugerido',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Selecionado',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Sugerido',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Encontrar pessoas',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Selecionado',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Encontrar etiquetas',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Encontrar espaços',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Conecte sua conta para ver os resultados que estão faltando',
  'dynamic-cards-search-page.connect_third_party_product_title': 'O administrador adicionou o {product}.',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': 'O {product} está disponível.',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'A data "De" deve ser anterior à data "Até"',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'A data "De" não pode estar no futuro',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'A data "Até" não pode estar no futuro',
  'dynamic-cards-search-page.date.filter.last.month': 'Últimos 30 dias',
  'dynamic-cards-search-page.date.filter.last.week': 'Últimos 7 dias',
  'dynamic-cards-search-page.date.filter.last.year': 'Ano passado',
  'dynamic-cards-search-page.document-search-result.google-docs-label': 'Documentos',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Palavra',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Gerar resposta',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Recentes',
  'dynamic-cards-search-page.error_primary': 'Há alguns problemas na pesquisa',
  'dynamic-cards-search-page.error_secondary':
    'Pode ser apenas um contratempo. O melhor a se fazer é <btn>tentar de novo</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Pessoas externas #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Limpar filtro',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'A qualquer momento',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Últimos 30 dias',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Últimos 7 dias',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Ano passado',
  'dynamic-cards-search-page.filter.last.updated.today': 'Hoje',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Ontem',
  'dynamic-cards-search-page.filter.type.answer': 'Respostas',
  'dynamic-cards-search-page.filter.type.attachment': 'Anexos',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogs',
  'dynamic-cards-search-page.filter.type.branch': 'Ramificações',
  'dynamic-cards-search-page.filter.type.calendar': 'Calendários',
  'dynamic-cards-search-page.filter.type.comment': 'Comentários',
  'dynamic-cards-search-page.filter.type.commit': 'Confirmações',
  'dynamic-cards-search-page.filter.type.component': 'Componentes',
  'dynamic-cards-search-page.filter.type.conversation': 'Conversas',
  'dynamic-cards-search-page.filter.type.database': 'Bancos de dados',
  'dynamic-cards-search-page.filter.type.design': 'Designs',
  'dynamic-cards-search-page.filter.type.documents': 'Documentos',
  'dynamic-cards-search-page.filter.type.folder': 'Pastas',
  'dynamic-cards-search-page.filter.type.issue': 'Itens',
  'dynamic-cards-search-page.filter.type.message': 'Mensagens',
  'dynamic-cards-search-page.filter.type.page': 'Páginas',
  'dynamic-cards-search-page.filter.type.placeholder': 'Encontrar tipo',
  'dynamic-cards-search-page.filter.type.presentation': 'Apresentações',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull requests',
  'dynamic-cards-search-page.filter.type.question': 'Perguntas',
  'dynamic-cards-search-page.filter.type.repository': 'Repositórios',
  'dynamic-cards-search-page.filter.type.space': 'Espaços',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Calendários do espaço',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Planilhas',
  'dynamic-cards-search-page.filter.type.video': 'Vídeos',
  'dynamic-cards-search-page.filter.type.web-page': 'Páginas da Web',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Quadros brancos',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Limpar tudo',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filtro',
  'dynamic-cards-search-page.filters.names.content': 'Conteúdo em',
  'dynamic-cards-search-page.filters.names.contributor': 'Colaborador',
  'dynamic-cards-search-page.filters.names.labels': 'Categoria',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Correspondência de título',
  'dynamic-cards-search-page.github-branch-result.label': 'Ramificação',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull request',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Pesquise qualquer coisa',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Encontrar projetos',
  'dynamic-cards-search-page.landing_primary': 'Comece a usar filtros para cartões dinâmicos',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Slides',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Fichas',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Não encontramos nenhum resultado para sua pesquisa',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Parece que alguns filtros foram aplicados. Remova os filtros.',
  'dynamic-cards-search-page.nouns.goal': 'Meta',
  'dynamic-cards-search-page.nouns.goals': 'Metas',
  'dynamic-cards-search-page.nouns.tag': 'Marcador',
  'dynamic-cards-search-page.nouns.tags': 'Marcadores',
  'dynamic-cards-search-page.number_of_results': 'Exibindo {numberOfResults,number} de {totalCount,number} resultados',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Houve uma falha na autorização para {product}.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'A autorização para {product} foi concedida.',
  'dynamic-cards-search-page.oauth-message-connect': 'Conectar',
  'dynamic-cards-search-page.products.custom-website': 'Página da web',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Ordenar por criado (mais recente)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Criado (mais recente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Atualizado (mais recente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Ordenar por atualizado (mais recente)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Alterar a ordem da lista',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Avançar',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtre por produto para ter resultados de pesquisa mais relevantes.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description-appify':
    'Filtre por aplicativo para ter resultados de pesquisa mais relevantes.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Pesquise em todas as áreas de trabalho da empresa',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Dependendo do produto pelo qual você está filtrando, essas opções mudam para ajudar você a conseguir resultados específicos.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description-appify':
    'Dependendo do aplicativo pelo qual você está filtrando, essas opções mudam para ajudar você a conseguir resultados específicos.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Encontre com exatidão o que você está procurando',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Anexo',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Anexado em {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Áudio',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Imagem',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Atualizado em {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Canal privado',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Remover ícone de pesquisa recente',
  'dynamic-cards-search-page.search-result.repository-label': 'Repositório',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Mensagem de grupo com usuários externos} =2 {{name1} e {name2}} =3 {{name1}, {name2} e {name3}} =4 {{name1}, {name2}, {name3} e outro {overflowContributorCount}} one {{name1}} other {{name1}, {name2}, {name3} e outros {overflowContributorCount}}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'canal desconhecido',
  'dynamic-cards-search-page.search_result_type_answer': 'Resposta',
  'dynamic-cards-search-page.search_result_type_card': 'Cartão',
  'dynamic-cards-search-page.search_result_type_commit': 'Confirmação',
  'dynamic-cards-search-page.search_result_type_component': 'Componente',
  'dynamic-cards-search-page.search_result_type_embed': 'Link inteligente',
  'dynamic-cards-search-page.search_result_type_folder': 'Pasta',
  'dynamic-cards-search-page.search_result_type_presentation': 'Apresentação',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull Request',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Documento do SharePoint',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Calendário do espaço',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Planilha',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Não reconhecido',
  'dynamic-cards-search-page.search_result_type_work_item': 'Ticket',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'O administrador adicionou o <strong>{product}.</strong>{br}Conecte sua conta para ver os resultados faltando, incluindo os documentos aos quais apenas você tem acesso.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>O {product} está disponível.</strong>{br} Conecte sua conta para ver os resultados faltando, incluindo os documentos aos quais apenas você tem acesso.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autorizar',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail':
    'Houve uma falha na autorização para {product}.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success':
    'A autorização para {product} foi concedida.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrar por todos os apps',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrar por mais apps',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Arquivado',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'Em risco',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Cancelado',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Concluído',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Fora dos trilhos',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'No caminho certo',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Pausado',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Itens pendentes',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} capítulo neste vídeo} other {{chapterCount,number} capítulos neste vídeo}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'ícone de vídeo',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Miniatura de vídeo',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'está atribuído(a)',
  'dynamic-cards-search-page.work-item-creator.created': 'criou',
  'dynamic-cards-search-page.work-item-status.for': 'para',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Ticket',
  'initialsAvatar.label': 'Avatar com iniciais',
  'personAvatar.label': 'Avatar da pessoa',
  'search-page.results.private-result-label': 'Privado',
  'search-page.results.private-result-tooltip': 'Visível apenas para você',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} membro} other {{memberCount,number} membros}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Canal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Canal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} membro} other {{count,number} membros}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Ativo pela última vez em {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'canal desconhecido',
  'search-page.results.product-results.third-party.external-people-label': 'Pessoas externas',
  'search-page.results.product-results.third-party.external-person-label': 'Pessoa externa',
  'search-page.results.product-results.third-party.last-active': 'Ativo pela última vez em {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Mensagem',
  'search-page.results.product-results.third-party.no-contributors-label': 'Pessoas externas em #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} em uma conversa privada',
  'search-page.results.product-results.third-party.thread-type-label': 'Tópico',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} em #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} e {remainingContributorsCount} outro} other {{title} e outros {remainingContributorsCount}}}',
  'search-page.results.restricted-result-label': 'Restrito',
  'search-page.results.restricted-result-tooltip': 'Visível apenas para pessoas específicas',
  'search-page.show-more-breadcrumbs-button-label': 'Mostrar mais trilhas',
  'search-page.verified-icon-label': 'Verificado',
  'search-page.verified-icon-tooltip-message': 'Esta página foi verificada por um proprietário ou administrador.',
  'search-result.result.count':
    '{count, plural, one {Mostrando {count} resultado} other {Mostrando {count} resultados}}',
  'search-result.user-mention.external-person': 'Pessoa externa',
};
